import {css} from 'lit';
export const styles = css`:host {
  --font: var(--font-size-xs);

  display: block;
  height: 100%;
  color: var(--link-text);
  text-align: center;
  font-size: var(--font);
}

  @media (min-width: 768px) {:host {
    --font: var(--font-size-base);

    width: 100%
}
  }

:host a {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 4px;
  padding-bottom: 8px;
}

@media (min-width: 768px) {

:host a {
    justify-content: flex-start;
    flex-direction: row;
    padding: 10px 8px;
    color: var(--dark-text);
    font-weight: 700;
    border-radius: 6px
}
  }

a.focus-visible {
  outline-offset: -4px;
}

a:focus-visible {
  outline-offset: -4px;
}

@media (hover: hover) {
  a:hover {
    color: var(--link-text-hover);
  }

  @media (min-width: 768px) {
    a:hover {
      --link-text-hover: var(--dark-text);

      background-color: var(--contrast-light);
    }
  }
}

a:active {
  color: var(--link-text);
}

@media (min-width: 768px) {

a:active {
    --link-text: var(--dark-text);

    background: var(--gray-300)
}
  }

a[active] {
  --link-text: var(--contrast-light);
  --link-text-hover: var(--primary-100);

  background-color: var(--primary-600);
}

@media (min-width: 768px) {

a[active] {
    --link-text-hover: var(--dark-text);

    background-color: var(--contrast-light-bg)
}
  }

ef-icon {
  --secondary: var(--badge-color);

  font-size: 2em;
}

@media (min-width: 768px) {

ef-icon {
    min-width: 24px;
    margin-right: 16px;
    justify-content: center;
    font-size: 1.25em
}
  }
`;
export default styles;
